(() => {
  const flagIconsSource = "//glidelif.com/cdn/shop/t/75/assets/partial-flag-icons.css?v=164190940160091988681789975483";

  const loadFlagIcons = () => {
    const existingLink = document.querySelector('[data-flag-icons-styles]');

    if (existingLink) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = flagIconsSource;
    link.dataset.flagIconsStyles = 'true';

    document.head.appendChild(link);
  };

  const scheduleFlagIconsLoad = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadFlagIcons, {
        timeout: 2500,
      });
      return;
    }

    window.setTimeout(loadFlagIcons, 1500);
  };

  if (document.readyState === 'complete') {
    scheduleFlagIconsLoad();
  } else {
    window.addEventListener('load', scheduleFlagIconsLoad, {
      once: true,
    });
  }
})();

(() => {
  const youtubeApiSource = 'https://www.youtube.com/iframe_api';

  const loadYouTubeApi = () => {
    if (window.YT?.Player) {
      window.onYouTubeIframeAPIReady?.();
      return;
    }

    const existingScript = document.querySelector('[data-youtube-iframe-api]');

    if (existingScript) return;

    const script = document.createElement('script');
    script.src = youtubeApiSource;
    script.async = true;
    script.dataset.youtubeIframeApi = 'true';

    document.head.appendChild(script);
  };

  const scheduleYouTubeApiLoad = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadYouTubeApi, {
        timeout: 2500,
      });
      return;
    }

    window.setTimeout(loadYouTubeApi, 1500);
  };

  if (document.readyState === 'complete') {
    scheduleYouTubeApiLoad();
  } else {
    window.addEventListener('load', scheduleYouTubeApiLoad, {
      once: true,
    });
  }
})();
